import utilCommon from '@/util/common'
import utilUri from '@/util/uri'
import client from './client'

export default {
  getAnswersByDrillId: (drillId, params = {}, token = null) => {
    return new Promise((resolve, reject) => {
      const options = utilUri.getReqOptions(params, token)
      const uri = `user/drills/${drillId}/answers`
      client
        .get(uri, options)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getAnswer: (answerId, params = {}, token = null) => {
    return new Promise((resolve, reject) => {
      const options = utilUri.getReqOptions(params, token)
      const uri = `user/answers/${answerId}`
      client
        .get(uri, options)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getDrills: (identifer, params = {}, token = null) => {
    return new Promise((resolve, reject) => {
      const options = utilUri.getReqOptions(params, token)
      const uri = identifer ? `user/drills/${identifer}` : 'user/drills'
      client
        .get(uri, options)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getDrillsCount: (params = {}, token = null) => {
    return new Promise((resolve, reject) => {
      const options = utilUri.getReqOptions(params, token)
      const uri = 'user/drills/count'
      client
        .get(uri, options)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  startDrill: (vals, token = null) => {
    return new Promise((resolve, reject) => {
      const options = utilUri.getReqOptions(null, token)
      const uri = 'user/drills'
      client
        .post(uri, vals, options)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err))
    })
  },

  startDrillForPost: (postId, token = null) => {
    return new Promise((resolve, reject) => {
      const options = utilUri.getReqOptions(null, token)
      const uri = `user/drills/posts/${postId}`
      client
        .post(uri, null, options)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err))
    })
  },

  updateDrillAnswer: (drillId, vals, token = null) => {
    return new Promise((resolve, reject) => {
      const options = utilUri.getReqOptions(null, token)
      const uri = `user/drills/${drillId}/answers`
      client
        .post(uri, vals, options)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err))
    })
  },

  updateDrillAnswerStatus: (drillId, answerId, answerStatus, token = null) => {
    const params = { answerStatus: answerStatus }
    return new Promise((resolve, reject) => {
      const options = utilUri.getReqOptions(null, token)
      const uri = `user/drills/${drillId}/answers/${answerId}/status`
      client
        .post(uri, params, options)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err))
    })
  },

  sendDrillAnswer: (drillId, answerId, params, token) => {
    return new Promise((resolve, reject) => {
      const options = utilUri.getReqOptions(null, token)
      const uri = `user/drills/${drillId}/answers/${answerId}`
      client
        .post(uri, params, options)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err))
    })
  },

  uploadDrillAnswerFiles: (drillId, answerId, params, token) => {
    return new Promise((resolve, reject) => {
      const options = utilUri.getReqOptions(null, token)
      const uri = `user/drills/${drillId}/answers/${answerId}/files`
      client
        .post(uri, params, options)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err))
    })
  },

  updateAnswer: (answerId, vals, token = null) => {
    return new Promise((resolve, reject) => {
      const options = utilUri.getReqOptions(null, token)
      const uri = `user/answers/${answerId}`
      client
        .post(uri, vals, options)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err))
    })
  },

  deleteAnswerImage: (answerId, fileName, token = null) => {
    return new Promise((resolve, reject) => {
      const options = utilUri.getReqOptions(null, token)
      const uri = `user/answers/${answerId}/images/${fileName}`
      client
        .delete(uri, options)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err))
    })
  },

  getPostsMastered: (serviceId, params = {}, token = null) => {
    return new Promise((resolve, reject) => {
      const options = utilUri.getReqOptions(params, token)
      const uri = `user/posts/${serviceId}/mastered`
      client
        .get(uri, options)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getPostsMasteredDetail: (serviceId, postId, token = null) => {
    return new Promise((resolve, reject) => {
      const options = utilUri.getReqOptions(null, token)
      const uri = `user/posts/${serviceId}/mastered/${postId}`
      client
        .get(uri, options)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  updateIsMastered: (serviceId, vals, token = null) => {
    return new Promise((resolve, reject) => {
      const options = utilUri.getReqOptions(null, token)
      const uri = `user/posts/${serviceId}/mastered`
      client
        .post(uri, vals, options)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err))
    })
  },

  getPostAnswers: (postId, params = {}, token = null) => {
    return new Promise((resolve, reject) => {
      const options = utilUri.getReqOptions(params, token)
      const uri = `user/answers/posts/${postId}`
      client
        .get(uri, options)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getPostAnswersCount: (postId, params = {}, token = null) => {
    return new Promise((resolve, reject) => {
      const options = utilUri.getReqOptions(params, token)
      const uri = `user/answers/posts/${postId}/count`
      client
        .get(uri, options)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
}
